import useRoutesHandler from "@/Hooks/useRouteHandler";
import { XMarkIcon } from "@heroicons/react/24/outline";
import {
  ArrowTrendingDownIcon,
  ArrowTrendingUpIcon,
} from "@heroicons/react/24/solid";
import { ButtonBase } from "@repo/ui/index.tsx";

export interface IShowCount {
  icon?: JSX.Element;
  valueComponent?: JSX.Element;
  labelComponent?: JSX.Element;
  className?: string;
  trend?: "up" | "down" | "";
  info?: JSX.Element;
  onClick?: () => void;
  isActive?: boolean;
  containerClass?: string;
  searchKey?: string;
}

export default function ShowCount({
  icon,
  valueComponent,
  labelComponent,
  className = "",
  trend = "",
  info,
  onClick,
  isActive = false,
  containerClass,
  searchKey = "",
}: IShowCount) {
  const { navigateBackTo } = useRoutesHandler();

  return (
    <div className={`relative rounded-lg ${containerClass}`}>
      {isActive && (
        <ButtonBase
          icon={<XMarkIcon className="size-4 text-body" />}
          buttonType="tertiary"
          className="absolute -right-2 -top-2 bg-white shadow-md rounded-full p-0.5 ring-1 ring-extraLightGray"
          onClick={() => navigateBackTo({ searchKey: searchKey })}
        />
      )}
      <button
        type="button"
        data-active={isActive}
        className={`py-2 px-4 flex flex-col gap-2 rounded-lg ring-1 ring-gray/30 
        data-[active=true]:ring-primary/50 w-full shadow-lg shadow-offWhite  ${className}`}
        onClick={onClick}
      >
        <section className="flex w-full items-center gap-2">
          {icon}
          {labelComponent}
        </section>
        <section className="flex items-center justify-between">
          {valueComponent}
          {trend ? (
            <span className="flex items-center">
              {trend === "up" ? (
                <ArrowTrendingUpIcon className="size-6 text-success" />
              ) : (
                <ArrowTrendingDownIcon className="size-6 text-error" />
              )}
            </span>
          ) : (
            <></>
          )}
          {info}
        </section>
      </button>
    </div>
  );
}
